module.exports = "img/videos/3.0545a0.mp4";